import { render, staticRenderFns } from "./DateAnonymisationField.vue?vue&type=template&id=1bced038&"
import script from "./DateAnonymisationField.vue?vue&type=script&lang=ts&"
export * from "./DateAnonymisationField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports